var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJwajem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0C020",
    d: "M222.131 154.51h-190.4l3.91-7 7.1-12.69c8.65-15.48 26.32-23.6 43.7-20.09l21.01 4.24c10.59 2.14 21.6-.01 30.61-5.98.56-.37 1.13-.73 1.7-1.06 16.67-9.9 38.16-6.72 51.22 7.85l7.57 8.44 17.3 19.29z",
    opacity: 1,
    "data-original": "#f0c020"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8A61E",
    d: "M222.131 154.51h-190.4l3.91-7h180.21z",
    opacity: 1,
    "data-original": "#e8a61e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72C2E9",
    d: "M249.251 166.16c0 6.44-5.22 11.66-11.66 11.66h-8.06l-1.66 7-12.06 51a20.001 20.001 0 0 1-19.46 15.39H59.711c-9.27 0-17.32-6.37-19.46-15.39l-12.06-51-1.66-7h-8.06c-6.44 0-11.66-5.22-11.66-11.66 0-6.43 5.22-11.65 11.66-11.65h219.12c6.44 0 11.66 5.22 11.66 11.65z",
    opacity: 1,
    "data-original": "#72c2e9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5E5FE",
    d: "M196.352 243.71H72.723a2.5 2.5 0 1 1 0-5h123.629a7.474 7.474 0 0 0 7.296-5.769l9.891-41.829a2.5 2.5 0 1 1 4.865 1.15l-9.891 41.831a12.456 12.456 0 0 1-12.161 9.617zm-133.629 0h-3.012a2.5 2.5 0 1 1 0-5h3.012a2.5 2.5 0 1 1 0 5z",
    opacity: 1,
    "data-original": "#c5e5fe"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EA4C3",
    d: "m229.531 177.82-1.66 7H28.191l-1.66-7z",
    opacity: 1,
    "data-original": "#4ea4c3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#B34F33"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.198,
    cy: 136.21,
    r: 6.667,
    fill: "#B34F33",
    opacity: 1,
    "data-original": "#b34f33"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.198,
    cy: 123.443,
    r: 6.667,
    fill: "#B34F33",
    opacity: 1,
    "data-original": "#b34f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.351 154.51h-13.31c-1.455-2.079-1.777-4.663-1.07-7 1.03-3.29 4.1-5.68 7.73-5.68 3.62 0 6.69 2.39 7.72 5.68.704 2.325.392 4.888-1.07 7z",
    fill: "#B34F33",
    opacity: 1,
    "data-original": "#b34f33"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#823A26",
    d: "M137.351 154.51h-13.31c-1.455-2.079-1.777-4.663-1.07-7h15.45c.704 2.325.392 4.888-1.07 7z",
    opacity: 1,
    "data-original": "#823a26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2E1D7",
    d: "M200.421 79.09c-1.96 3.52-1.56 7.86.96 10.99 6.7 8.35 8.37 19.14 1.25 31.97a47.42 47.42 0 0 1-4.08 6.17l-7.57-8.44c-13.06-14.57-34.55-17.75-51.22-7.85.071-16.638 11.44-40.031 33.55-37.41 4 .48 7.89-1.48 9.84-5l27.87-50.28c2.657-4.771 8.667-6.495 13.42-3.85 4.77 2.65 6.49 8.65 3.85 13.42z",
    opacity: 1,
    "data-original": "#f2e1d7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.416,
    cy: 51.333,
    r: 30.266,
    fill: "#F0C020",
    opacity: 1,
    "data-original": "#f0c020"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.883,
    cy: 59.152,
    r: 5.517,
    fill: "#B34F33",
    opacity: 1,
    "data-original": "#b34f33"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.662,
    cy: 37.617,
    r: 5.517,
    fill: "#B34F33",
    opacity: 1,
    "data-original": "#b34f33"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.752,
    cy: 51.333,
    r: 5.517,
    fill: "#B34F33",
    opacity: 1,
    "data-original": "#b34f33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C020",
    d: "M164.833 45.817c-4.288-1.417-8.716-2.655-11.202-13.364-2.29 9.864-5.958 11.632-11.202 13.364 8.552 2.826 9.842 7.505 11.202 13.364 2.344-10.1 6.22-11.718 11.202-13.364zM240.731 88.892c-4.288-1.417-8.716-2.655-11.202-13.364-2.29 9.864-5.958 11.632-11.202 13.364 8.552 2.826 9.842 7.505 11.202 13.364 2.343-10.1 6.22-11.718 11.202-13.364z",
    opacity: 1,
    "data-original": "#f0c020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.031 177.816c0-1.37-1.12-2.49-2.5-2.49s-2.5 1.12-2.5 2.49a2.5 2.5 0 0 0 5 0zM82.201 127.046c-5.061 0-9.17 4.11-9.17 9.16 0 5.06 4.109 9.17 9.17 9.17 5.05 0 9.16-4.11 9.16-9.17 0-5.05-4.11-9.16-9.16-9.16zm0 13.33c-2.29 0-4.16-1.87-4.17-4.17.01-2.29 1.88-4.16 4.17-4.16s4.16 1.87 4.16 4.16c0 2.3-1.87 4.17-4.16 4.17zM162.201 132.606c5.05 0 9.16-4.11 9.16-9.16 0-5.06-4.11-9.17-9.16-9.17-5.061 0-9.17 4.11-9.17 9.17 0 5.05 4.11 9.16 9.17 9.16zm0-13.33c2.29 0 4.16 1.87 4.16 4.17a4.17 4.17 0 0 1-4.16 4.16c-2.3 0-4.17-1.87-4.17-4.16 0-2.3 1.87-4.17 4.17-4.17zM35.341 215.056a2.508 2.508 0 0 0 1.86-3.01c-.32-1.32-1.68-2.17-3.01-1.86a2.506 2.506 0 0 0-1.86 3.01c.307 1.289 1.575 2.163 3.01 1.86z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.471 180.316h6.08l5.48 23.15c.31 1.32 1.67 2.17 3.01 1.86a2.515 2.515 0 0 0 1.86-3.01l-5.213-22h156.843a2.5 2.5 0 0 0 2.5-2.5c0-1.37-1.12-2.49-2.5-2.49-163.184 0-167.733-.01-168.061-.01-5.04 0-9.149-4.11-9.159-9.16.01-5.03 4.119-9.14 9.159-9.15h219.12c5.04.01 9.15 4.12 9.16 9.15-.01 5.05-4.12 9.16-9.16 9.16-.603 0-8.219.01-31.06.01-1.38 0-2.5 1.12-2.5 2.49a2.5 2.5 0 0 0 2.5 2.5h19.843l-12.994 54.93a17.44 17.44 0 0 1-17.03 13.46H59.711a17.434 17.434 0 0 1-17.03-13.46l-3.18-13.47c-.32-1.32-1.68-2.17-3.01-1.86a2.515 2.515 0 0 0-1.86 3.01l3.19 13.47c2.387 10.104 11.449 17.31 21.89 17.31h136.64c10.424 0 19.5-7.191 21.891-17.31l13.27-56.08h6.08c7.811 0 14.16-6.35 14.16-14.16 0-7.8-6.35-14.14-14.16-14.15h-14.353l-21.464-23.93a49.719 49.719 0 0 0 3.048-4.809c6.6-11.891 6.995-24.205-1.49-34.75-1.87-2.306-2.201-5.561-.73-8.21l27.881-50.28c3.331-6.069 1.092-13.542-4.83-16.82-5.914-3.314-13.466-1.181-16.811 4.82l-27.88 50.28a7.358 7.358 0 0 1-5.49 3.72c-3.292.451-2.601 5.391.65 4.96 3.88-.5 7.32-2.84 9.22-6.25l27.87-50.28c1.918-3.453 6.351-4.909 10.01-2.88 3.422 1.9 4.923 6.281 2.88 10.03l-27.869 50.27c-2.476 4.44-1.92 9.893 1.199 13.77 7.175 8.962 6.646 19.026 1.011 29.19a46.095 46.095 0 0 1-2.091 3.41l-5.51-6.13c-12.612-14.073-33.041-18.406-50.33-10.45 1.148-10.149 6.812-22.057 15.36-27.47a2.495 2.495 0 0 0 .77-3.45c-.71-1.12-2.31-1.49-3.449-.77-10.651 6.731-17.406 21.555-17.878 34.523a48.34 48.34 0 0 0-.633.407c-8.853 5.86-19.303 7.542-28.739 5.61l-21.011-4.24c-18.379-3.728-37.183 4.87-46.369 21.33l-10.289 18.4H18.471c-7.81.01-14.159 6.35-14.159 14.15 0 7.809 6.349 14.159 14.159 14.159zm117.41-28.31h-10.37c-1.498-3.613 1.237-7.68 5.181-7.68h.02c3.882 0 6.654 3.963 5.169 7.68zm-90.96-15.97c7.993-14.308 24.431-22.191 41.021-18.86l21.01 4.24a43.262 43.262 0 0 0 32.49-6.34c.6-.4 1.109-.72 1.569-.98l.03-.02c15.557-9.24 35.611-6.379 48.08 7.37l27.41 30.56h-75.462c1.308-6.536-3.635-12.666-10.368-12.68a10.575 10.575 0 0 0-10.381 12.68H35.991z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.211 77.076c1.36-.21 2.3-1.48 2.09-2.85-.21-1.33-1.51-2.29-2.85-2.09h-.01c-1.37.207-2.294 1.507-2.091 2.85.209 1.323 1.463 2.306 2.861 2.09zM51.881 51.136c-4.42 0-8.01 3.6-8.02 8.02.01 4.41 3.6 8.01 8.02 8.01s8.021-3.6 8.021-8.01c-.001-4.42-3.601-8.02-8.021-8.02zm0 11.03c-1.66 0-3.01-1.35-3.02-3.01.01-1.66 1.359-3.02 3.02-3.02s3.01 1.36 3.021 3.02a3.03 3.03 0 0 1-3.021 3.01zM66.681 37.616c0-4.42-3.6-8.01-8.02-8.01s-8.021 3.59-8.021 8.01 3.601 8.02 8.021 8.02 8.02-3.6 8.02-8.02zm-8.02 3.02a3.045 3.045 0 0 1-3.021-3.02 3.044 3.044 0 0 1 3.021-3.02c1.66.01 3.01 1.36 3.02 3.02a3.043 3.043 0 0 1-3.02 3.02zM72.751 59.346c4.42 0 8.01-3.6 8.021-8.01-.011-4.42-3.601-8.02-8.021-8.02s-8.01 3.6-8.01 8.02c0 4.41 3.59 8.01 8.01 8.01zm0-11.03c1.66 0 3.01 1.36 3.021 3.02-.011 1.66-1.36 3.01-3.021 3.01s-3.01-1.35-3.02-3.01c.01-1.66 1.36-3.02 3.02-3.02zM86.721 34.536a2.506 2.506 0 0 0 .41-3.51c0-.01-.01-.01-.01-.01-.83-1.04-2.45-1.23-3.5-.4a2.494 2.494 0 0 0-.42 3.5v.01a2.508 2.508 0 0 0 3.52.41z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.151 23.786c-5.28-3.42-11.41-5.22-17.73-5.22-18.135 0-32.77 14.68-32.77 32.77 0 18.063 14.605 32.76 32.77 32.76 18.109 0 32.76-14.653 32.76-32.76 0-3.72-.619-7.38-1.85-10.88-.45-1.26-1.91-1.97-3.19-1.53a2.5 2.5 0 0 0-1.52 3.19c1.03 2.95 1.56 6.05 1.56 9.22-.029 15.28-12.479 27.74-27.76 27.76-15.29-.02-27.74-12.48-27.77-27.76.029-15.29 12.479-27.74 27.77-27.77 5.34 0 10.54 1.53 15.021 4.42 1.13.72 2.739.37 3.46-.75.749-1.16.41-2.71-.751-3.45z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.421 2.106c-20.801 0-38.814 12.908-45.99 31.61a2.503 2.503 0 0 0 1.44 3.23c1.26.48 2.75-.2 3.229-1.44 6.521-16.99 23.12-28.41 41.32-28.41 36.726.03 57.082 42.044 35.29 70.89-.58.76-.67 1.8-.24 2.64l5.971 11.73-11.73-5.96c-.83-.43-1.899-.33-2.64.23-27.927 21.134-68.667 2.666-70.8-32.56-.091-1.37-1.28-2.44-2.65-2.34-1.412.084-2.43 1.313-2.35 2.65 2.375 38.571 46.378 59.214 77.54 37.17l17.199 8.75c2.117 1.081 4.48-1.209 3.36-3.36l-8.74-17.2c22.847-32.291-.107-77.63-40.209-77.63z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.841 46.726c1.319.22 2.634-.726 2.851-2.1a2.504 2.504 0 0 0-2.101-2.84c-1.35-.21-2.64.76-2.85 2.09-.2 1.36.74 2.64 2.1 2.85zM141.591 48.355c7.348 2.428 8.178 6.009 9.435 11.43.638 2.746 4.571 2.752 5.21 0 2.089-9.002 5.17-10.02 9.436-11.429 2.443-.807 2.437-4.273 0-5.078-4.071-1.349-7.291-2.192-9.436-11.43-.636-2.744-4.571-2.752-5.209 0-2.09 9.003-5.171 10.021-9.436 11.43-2.443.807-2.437 4.272 0 5.077zm12.051-7.929c1.394 2.622 3.009 4.282 4.674 5.418-1.747 1.175-3.303 2.79-4.624 5.23-1.059-1.883-2.574-3.663-4.885-5.192 1.836-1.204 3.463-2.875 4.835-5.456zM226.924 74.923c-2.09 9.003-5.172 10.021-9.436 11.43-2.443.807-2.437 4.273 0 5.078 7.348 2.428 8.178 6.009 9.435 11.43.638 2.746 4.571 2.752 5.21 0 2.089-9.002 5.17-10.02 9.436-11.429 2.443-.807 2.437-4.273 0-5.078-4.071-1.349-7.291-2.192-9.436-11.43-.636-2.745-4.57-2.753-5.209-.001zm7.29 13.996c-1.747 1.175-3.303 2.79-4.624 5.23-1.059-1.883-2.574-3.663-4.885-5.192 1.836-1.204 3.464-2.875 4.835-5.456 1.394 2.622 3.009 4.282 4.674 5.418z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJwajem);
export default __webpack_public_path__ + "static/media/Jwajem.bbdf5a4a80a334d96c87f81648dcbf85.svg";
export { ForwardRef as ReactComponent };